// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

mat-icon {
  font-size: 26px;
  margin-left: 10px;
}

h1 {
  font-size: 1.5rem;
}

mat-paginator {
  direction: ltr !important;
  margin: auto !important;
}

.parent-both {
  display: flex;
  margin: auto;
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/request-rial/request-rial.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/request-rial/request-rial.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ACCJ;;ADCE;EACE,eAAA;EACE,iBAAA;ACEN;;ADCE;EACE,iBAAA;ACEJ;;ADAE;EACE,yBAAA;EACA,uBAAA;ACGJ;;ADDE;EACE,aAAA;EACA,YAAA;EACA,aAAA;ACIJ","sourcesContent":[".title{\r\n    margin-bottom: 10px;\r\n    margin-top: 10px;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  mat-icon{\r\n    font-size: 26px;\r\n      margin-left: 10px;\r\n  }\r\n\r\n  h1{\r\n    font-size: 1.5rem;\r\n  }\r\n  mat-paginator{\r\n    direction: ltr !important;\r\n    margin: auto !important;\r\n  }\r\n  .parent-both{\r\n    display: flex;\r\n    margin: auto;\r\n    padding: 20px;\r\n  }",".title {\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\nmat-icon {\n  font-size: 26px;\n  margin-left: 10px;\n}\n\nh1 {\n  font-size: 1.5rem;\n}\n\nmat-paginator {\n  direction: ltr !important;\n  margin: auto !important;\n}\n\n.parent-both {\n  display: flex;\n  margin: auto;\n  padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
